import { sessionState } from "@/state"

export const scrubEntityKey = function(entityKey) {
    return entityKey?.replace(/-/g, "")
}

export const isEntityInCalifornia = function() {
    return sessionState.getProperty("state") === "CA"
}

export const isEntityInIllinois = function() {
    return sessionState.getProperty("state") === "IL"
}
